import requests from "./base";

const Plan = {
    getPlan: () => requests.get(`api/payment/products/`),
    subscription: data => requests.post('api/payment/subscription/', data),
    cancelSubscription: id => requests.patch(`api/payment/subscription/${id}/cancel/`),
};

export default Plan;